<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Trap Teams</h1>
        <div class="pull-right">
          <button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({})">Create New</button>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">All</h3>
      </div>
      <div class="panel-body">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped table-bordered table-hover table-fixed">
            <thead>
            <tr>
              <th>Name</th>
              <th>Contracts</th>
              <th width="120"></th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="item in form.list">
              <td>{{ item.attributes.name }}</td>
              <td class="text-center"><span v-if="item.attributes.contracts.length">{{ item.attributes.contracts.length }}</span></td>
              <td>
                <a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>
                <a class="pointer text-danger" v-on:click="form.destroy(item.id)"><i class="fa fa-times"></i></a>
              </td>
            </tr>


            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="edit">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{form.modal.title}}</h4>
          </div>
          <div class="modal-body">
            <form @submit.prevent="form.onSubmit({updateStore: true})" @keydown="form.errors.clear($event.target.id)">
              <input type="hidden" name="id" v-model="form.id">
              <div class="form-group" :class="{'has-error': form.errors.has('name') }">
                <label class="control-label">Name</label>
                <input type="text" class="form-control" id="name" v-model="form.data.name">
                <span class="help-block" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
              </div>

              <div class="form-group" :class="{'has-error': form.errors.has('contracts') }">
                <label class="control-label">Contracts</label>
                <div v-for="(contract, index) in form.data.contracts">
                  <div class="input-group">
                    <span class="input-group-addon">{{index + 1}}</span>
                    <select class="form-control" v-model="form.data.contracts[index]">
                      <option></option>
                      <option v-for="c in contracts" v-bind:value="c.id">{{c.attributes.name}}</option>
                    </select>
                    <span class="input-group-addon"><i class="fa fa-trash pointer" v-on:click="form.removeContract(index)" title="Remove contract"></i></span>
                  </div>
                </div>
                <button class="btn btn-small" v-on:click.prevent="form.addContract()" title="Add contract"><i class="fa fa-plus"></i></button>
                <span class="help-block" v-if="form.errors.has('contracts')" v-text="form.errors.get('contracts')"></span>
              </div>

              <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
              <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
            </form>
          </div>
          <div class="modal-footer">
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

  </div>
</template>

<script>
  import TrapTeamsService from '@/services/TrapTeamsService';
  import Form from '@/utils/form';
  import LoadingButton from '@/components/loading-button';


  export default {
    name: 'trap-teams',

    components: {
      LoadingButton
    },

    data() {
      return {
        form: new Form(
          TrapTeamsService,
          {
            name: null,
            contracts: []
          }),
        contracts: []
      }
    },

    mounted() {
      this.form.getList();
      this.form.getContracts()
        .then((data) => {
          this.contracts = data.data;
        });
    }

  }
</script>

<style lang="scss">

</style>